module.exports = __webpack_public_path__ + "img/18.6fa25bf.jpg";